import React, { useState } from 'react'
import { useAuth } from '../../../../context/auth';
import { showMessage } from '../../../../helpers/message';
import ModalCustomized from '../../../../components/Modal/Modal';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

export default function ModeloImpressao({ SelecionarModeloImpressao, setSelecionarModeloImpressao }) {
    const { setLoading } = useAuth();
    const [isOpenModal, setIsOpenModal] = useState(!!SelecionarModeloImpressao ? true : false)

    async function handleImpressaoInscricaoDividaAtiva() {
        setLoading(true);
        try {
            const url = `/empty/ImpressaoInscricaoDividaAtiva?hash=${SelecionarModeloImpressao.fiscalizacaoInfracao_Hash}`;
            window.open(url, "_blank", "noopener,noreferrer");
        } catch (error) {
            showMessage("Error", error?.message ?? error, "error", null);
        } finally {
            setLoading(false);
        }
    }

    async function handleImpressaoTermoSolicitacaoInscricaoDividaAtiva() {
        setLoading(true);
        try {
            const url = `/empty/ImpressaoTermoSolicitacaoInscricaoDividaAtiva?hash=${SelecionarModeloImpressao.fiscalizacaoInfracao_Hash}`;
            window.open(url, "_blank", "noopener,noreferrer");
        } catch (error) {
            showMessage("Error", error?.message ?? error, "error", null);
        } finally {
            setLoading(false);
        }
    }

    function handleCloseModal() {
        setSelecionarModeloImpressao(null)
        setIsOpenModal(false)
    }
    return (
        <ModalCustomized
            size={'md'}
            fullscreen={"lg"}
            toggle={handleCloseModal}
            widthPadrao={false}
            isOpen={isOpenModal}
            btnClose={handleCloseModal}
            title={"Selecionar Modelo de Impressão"}
        >
            <Row className='d-flex flex-column justify-content-center align-items-center'>
                <Col md={12} lg={12} className="mb-2">
                    <Button
                        color='secondary'
                        className='text-white fw-bold w-100'
                        onClick={handleImpressaoInscricaoDividaAtiva}
                    >
                        <FontAwesomeIcon icon={faFileAlt} /> Ficha de Inscrição em Dívida Ativa
                    </Button>
                </Col>
                <Col md={12} lg={12} className="mb-2">
                    <Button
                        color='secondary'
                        className='text-white fw-bold w-100'
                        onClick={handleImpressaoTermoSolicitacaoInscricaoDividaAtiva}
                    >
                        <FontAwesomeIcon icon={faFileAlt} /> Termo de Solicitação de Inscrição em Dívida Ativa
                    </Button>
                </Col>
            </Row>

        </ModalCustomized>
    )
}
